import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classes } from '../classes';
export const Callout = ({ variant, title, children }) => {
    return (_jsxs("div", { className: classes('callout', variant ?? 'note'), children: [title && _jsx("div", { className: "title", children: title }), _jsx("div", { className: "body", children: children })] }));
};
